import { SettingsCard, TextField, TextAreaField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function MarkaKimlik({ settings, update }: SettingsTabProps) {
  return (
    <SettingsCard
      title="Marka & Site Kimliği"
      description="Sitenin adı, sloganı ve açıklaması. Tarayıcı sekmesi, arama sonuçları ve tanıtım metinlerinde görünür."
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <TextField
            label="Site Adı"
            value={settings.siteName}
            onChange={(v) => update({ siteName: v })}
            placeholder="Örn. DersDinle"
            hint="Tarayıcı başlığında ve logoda kullanılır."
          />
          <TextField
            label="Slogan"
            value={settings.tagline}
            onChange={(v) => update({ tagline: v })}
            placeholder="Örn. Derslerin Sesi, Başarının Yolu..."
            hint="Kısa ve akılda kalıcı bir tanım."
          />
        </div>
        <TextAreaField
          label="Site Açıklaması"
          value={settings.siteDescription}
          onChange={(v) => update({ siteDescription: v })}
          placeholder="Platformun ne yaptığını kısaca anlatın."
          hint="Arama motorları ve sosyal medya paylaşımlarında kullanılır. Maksimum 500 karakter."
          rows={3}
        />
      </div>
    </SettingsCard>
  );
}